<template>
  <svg
      xmlns:dc="http://purl.org/dc/elements/1.1/"
      xmlns:cc="http://creativecommons.org/ns#"
      xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
      xmlns:svg="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 12.7 12.7"
      version="1.1"
      id="svg1344">
    <defs
        id="defs1338"/>
    <metadata
        id="metadata1341">
      <rdf:RDF>
        <cc:Work
            rdf:about="">
          <dc:format>image/svg+xml</dc:format>
          <dc:type
              rdf:resource="http://purl.org/dc/dcmitype/StillImage"/>
          <dc:title></dc:title>
        </cc:Work>
      </rdf:RDF>
    </metadata>
    <g
        id="layer1"
        transform="translate(0,-284.3)">
      <path
          style="vector-effect:none;fill:#ffffff;fill-opacity:1;stroke:#4d4d4d;stroke-width:0.27895883;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
          d="m 3.9045495,291.93683 c -1.4846071,0.27294 -1.116214,3.13439 -0.7059595,4.768 l 1.2146236,-1.75409"
          id="path1827-0-7-5-1"/>
      <path
          style="vector-effect:none;fill:#ffffff;fill-opacity:1;stroke:#4d4d4d;stroke-width:0.27895883;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
          d="m 9.2673581,291.98752 c 1.4726669,0.32736 0.9907019,3.17316 0.5157629,4.79049 l -1.1439093,-1.79752 z"
          id="path1827-9-4-1-4-1"/>
      <path
          :style="'vector-effect:none;fill:'+color+';fill-opacity:1;stroke:#4d4d4d;stroke-width:0.28306;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1'"
          d="m 7.9310236,295.64239 0.010829,-0.56129 0.7161233,1e-5 c 0.4446934,-3.17427 1.7571711,-6.38749 -2.1179997,-10.38089 -4.0688219,4.07653 -2.5016274,7.19205 -2.1118519,10.38088 l 0.7161233,1e-5 -0.010835,0.56128 1.3988086,-10e-6 z"
          id="rocketbody"/>
      <rect
          style="opacity:1;vector-effect:none;fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:0.38336545;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;marker:none"
          id="rect2013"
          width="2.3053925"
          height="0.76846427"
          x="-283.20438"
          y="63.237007"
          ry="0.3762269"
          transform="rotate(-78.333996)"/>
      <path
          style="opacity:1;vector-effect:none;fill:#ffffff;fill-opacity:1;stroke:#4d4d4d;stroke-width:0.27260208;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
          d="m 6.9902438,292.01716 c 1.1987497,-0.83822 0.8156348,3.47526 0.2749505,5.24314 l -0.2784211,-2.10525 z"
          id="path1895-8-34-8-0"/>
    </g>
  </svg>

</template>

<script>
export default {
  name: "Rocket",
  props: {
    color: {
      type: String,
      default: '#ffcc00',
    }
  },
}
</script>

<style scoped>

</style>